import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import { type FC } from 'react';

import ChipGroup from '../../../components/ChipGroup.jsx';
import { ApprovalTableItemData } from '../../../types/approversTable.js';
import type { ApproverEntity } from '../../../types/shared.js';

type Props = CustomCellRendererProps<ApprovalTableItemData, ApproverEntity[]>;

const ApproverCell: FC<Props> = ({ value }) => {
  if (!value?.length) {
    return null;
  }

  return (
    <div className="py-1">
      <ChipGroup items={value} maxVisibleChipsCount={5} />
    </div>
  );
};

export default ApproverCell;
